import { CartService } from '@/core/services/cart.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  constructor(private router: Router, private cartService: CartService) { }

  signOut() {
    localStorage.clear();
    this.cartService.dispose();
    this.router.navigate(['/sign-in']);
  }
}
